var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.runningTime)?_c('span',{staticClass:"blink_me"},[_vm._v(_vm._s(_vm._f("formatTime")(_vm.runningTime)))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }